import type { ApiResponse, Contact } from '@/models/api'
import { api, readData } from '@/services/apiClient'

export interface ContactDetailInput {
  contactMethodId: number
  detail: string
  default: boolean
}

export interface ContactInput {
  id?: string | null
  customerId: string
  titleId: number
  firstname: string
  lastname: string
  position: string | null
  background: string | null
  defaultContact: boolean
  details: ContactDetailInput[]
}

export async function loadContacts(customerId: string): Promise<Contact[]> {
  const { data } = await api.get<ApiResponse<Array<Contact & { customerId?: string; customerName?: string | null }>>>(`/contacts/customer/${customerId}`)
  return readData(data, []).map((row) => ({
    ...row,
    organisationId: row.organisationId || row.customerId || customerId,
    organisationName: row.organisationName || row.customerName || null,
    details: row.details ?? [],
  }))
}

export async function saveContact(input: ContactInput): Promise<string> {
  const { data } = await api.post<ApiResponse<string>>('/contacts', {
    id: input.id ?? null,
    customerId: input.customerId,
    titleId: input.titleId,
    firstname: input.firstname,
    lastname: input.lastname,
    position: input.position,
    background: input.background,
    defaultContact: input.defaultContact,
    details: input.details,
  })
  return readData(data, input.id ?? '')
}

export async function deleteContact(id: string): Promise<void> {
  const { data } = await api.delete<ApiResponse<null>>(`/contacts/${id}`)
  readData(data, null)
}
